import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { signIn, setName, setEmail, setRole, setAdmin, setApprover, setEditor, setBookGroup,setLoading } from "../../actions/authAction";
import history from "../../history";
import api from "../../api/api";
import uri from "../../variables/uri";

class AutoLogin extends React.Component {
 

    componentDidMount = async () => {
        //this.props.match.params.jwt
        var windowUrl = window.location.hash.toString();
        windowUrl = windowUrl.replace("#/AutoLogin/jwt","")
        const sp = new URLSearchParams(windowUrl);
        this.onVerifyToken(sp.get("jwt"))
        //this.onVerifyToken(this.props.match.params.jwt);
    };
 
  
    onVerifyToken = async (jwt) => {
        this.props.setLoading(true);
        try
        {
            var body = {
                JwtToken:jwt
            }
            var verifyToken = await api.customAutoLogin(uri.POST_VERIFY_TOKEN_STEP2, body);
            if (verifyToken.status === 200) {
                console.log(verifyToken)
                localStorage.setItem('username', verifyToken.data.sAMAcountName);
                this.handleSignIn(verifyToken);
                this.props.setLoading(false);
            }
        }catch(ex){
            this.props.setLoading(false);
        }
    };

    handleSignIn = async (response) => {
        this.props.signIn();
        this.props.setEmail(response.data.mail);
        if(response.data.givenName != null){
            this.props.setName(`${response.data.givenName} ${response.data.sn}`);
        }else{
            this.props.setName(`${response.data.displayName}`);
        }
        try {
            const role = await api.get(`${uri.GET_ROLE}?userId=${response.data.sAMAcountName}`);
            this.props.setRole(role.data);
        } catch (ex) {

        }
        try {
            const permis = await api.get(`${uri.GET_PERMISSION}?userId=${response.data.sAMAcountName}`);
            if(permis.status === 200){
                this.props.setAdmin(permis.data.IsAdmin);
                this.props.setApprover(permis.data.IsApprover);
                this.props.setEditor(permis.data.IsEditor);
                this.props.setBookGroup(permis.data.BookGroups);
            }
        } catch (ex) {

        }
        history.push(`/home/${response.data.sAMAcountName}`);
        this.setState({ isLoading: false });
    }
 
  render() {
     
    return (
      <div className="home flex-v">
         
      </div>
    );
  }
}

export default connect(null, {
    signIn,
    setEmail,
    setName,
    setRole,
    setAdmin,
    setApprover,
    setEditor,
    setBookGroup,
    setLoading
})(AutoLogin);
